import utils from "@/utilities/Utils";
import { UserRole, UserStatus } from "@/model/Enums";
import { mapData } from "@/utilities/DataMapping";

export interface IUser {
    id: string;
    occupancyID: string;
    role: UserRole;
    status: UserStatus;
    statusInfo: string;
    email: string;
    forename: string;
    surname: string;
    lastLoggedIn: Date;
    prevLastLoggedIn: Date;
    jwtBearerToken: string;
}

export class User implements IUser {

    constructor(data?: IUser) {
        if (data) this.update(data);
    }

    update(data: IUser) {
        mapData(data, { root: () => this });
    }

    id: string = utils.emptyGuidValue;
    occupancyID: string = utils.emptyGuidValue;
    role: UserRole = UserRole.None;
    status: UserStatus = UserStatus.None;
    statusInfo: string = "";
    email: string = "";    
    forename: string = "";
    surname: string = "";    
    lastLoggedIn: Date = new Date(utils.emptyDateValue);
    prevLastLoggedIn: Date = new Date(utils.emptyDateValue);
    jwtBearerToken: string = "";

    get fullname() {
        return this.forename + " " + this.surname;
    }
    
}